<template>
  <div class="bg-white">
    <p v-if="isDev" class="p-2 font-medium-3 font-weight-bold">
      Đây là môi trường phát triển vui lòng vào môi trường chính thức
      <a href="https://vc.itel.vn/videoCall/QuanLyDTV">Tại đây!</a>
    </p>
    <div class="wrap-content">
      <div class="d-flex w-100">
        <b-col lg="4" class="d-flex  align-items-baseline ">
          <h4 class="mr-2">Số thuê bao</h4>
          <b-form-input
            type="text"
            class="w-75"
            placeholder="087..."
            v-model="phone"
            @input="ResetMessage"
          ></b-form-input>
        </b-col>
        <b-col lg="4" class="d-flex  align-items-baseline">
          <h4 class="mr-2">Msin</h4>
          <b-form-input
            type="text"
            class="w-75"
            placeholder="08..."
            v-model="msin"
            @input="ResetMessage"
          ></b-form-input>
        </b-col>
        <b-col
          lg="4"
          class="d-flex justify-content-end pr-0 align-items-baseline"
        >
          <h4 class="mr-2">SĐT liên hệ</h4>
          <b-form-input
            type="text"
            class="w-75"
            placeholder="0..."
            v-model="contactPhone"
            @input="ResetMessage"
          ></b-form-input>
        </b-col>
      </div>
      <div class="d-flex justify-content-between align-items-baseline mt-2">
        <p
          class="font-medium-2"
          :class="isFalse ? 'text-danger' : 'text-success'"
        >
          {{ statusMessage }}
        </p>
        <button class="btn btn-primary px-4" @click="CheckStatusNumber">
          Kiểm tra
        </button>
      </div>
      <div class="mt-4">
        <h4>Link cuộc gọi</h4>
        <div class="d-flex">
          <b-form-input
            type="text"
            class="w-75 bg-white"
            placeholder="Link"
            ref="videoLink"
            readonly
          ></b-form-input>
          <button class="btn btn-primary w-25" @click="copyCode">
            Copy Link
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCol, BFormInput } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { $ctx } from "@themeConfig";

export default {
  name: "VideoCallDKTT",
  components: {
    BFormInput,
    BCol
  },
  data() {
    return {
      phone: "",
      msin: "",
      statusMessage: "",
      isFalse: false,
      contactPhone: "",
      isDev: $ctx.API_URL.includes("dev")
    };
  },
  methods: {
    showLoading(options) {
      document.getElementById("loading-bg").style.display = options;
    },
    copyCode() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Copy code thành công!",
          icon: "CheckSquareIcon",
          variant: "success"
        }
      });
      navigator.clipboard.writeText(this.$refs.videoLink.value);
    },
    CheckStatusNumber() {
      this.showLoading("block");
      if (this.phone.length !== 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Số thuê bao bắt đầu bằng số 0 và có 10 chữ số",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        this.showLoading("none");
        return;
      }
      if (this.msin.length !== 11) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Msin phải có 11 chữ số",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        this.showLoading("none");
        return;
      }
      if (
        !this.contactPhone.startsWith("0") ||
        this.contactPhone.length !== 10
      ) {
        this.showLoading("none");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Số liên hệ bắt đầu bằng số 0 và có 10 chữ số",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        return;
      }
      if (this.phone === "0877889293" || this.phone === "84877889293") {
        this.showLoading("none");
        this.$toast({
          component: ToastificationContent,
          props: {
            title:
              "SỐ 0877889293 THANH TRA KHÔNG ĐƯỢC TẠO LINK, BÁO KHÁCH HÀNG RA PHÒNG GIAO DỊCH ĐỂ DKTT",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        return;
      }
      useJwt
        .post("check_status_number", {
          phone: this.phone,
          seri: this.msin,
          contactPhone: this.contactPhone
        })
        .then(res => {
          const key = (parseInt(this.phone.slice(-3)) + 112) * 2;
          this.$refs.videoLink.value =
            $ctx.URL_FRONTEND +
            "/DKTT/" +
            this.phone +
            "/" +
            this.msin +
            "/" +
            this.contactPhone +
            "/" +
            key;
          this.showLoading("none");
          this.statusMessage = res.data.message;
          this.isFalse = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: "CheckSquareIcon",
              variant: "success"
            }
          });
        })
        .catch(err => {
          this.showLoading("none");
          this.statusMessage = err.response.data.message;
          this.isFalse = true;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    ResetMessage() {
      this.statusMessage = "";
      this.$refs.videoLink.value = "";
    }
  }
};
</script>

<style scoped lang="scss">
.wrap-content {
  padding: 3rem 4rem 3rem 2rem;
}
</style>
